/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { productImageCarouselStyles } from "@insite/content-library/Components/ProductImageCarousel";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const imageCss = css`
    width: 50px;
    height: 50px;
    border: 1px solid ${getColor("common.ui12")};
    cursor: pointer;
    justify-content: flex-start;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 10px;
    opacity: 33%;
    transition: all 0.2s linear;

    img {
        height: 100%;
        object-fit: contain;
        object-position: center;
    }

    &:hover {
        opacity: 100%;
    }
`;

const carouselArrowCss = css`
    &&& {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: ${getColor("common.ui1")};
        opacity: 70%;
        padding: 0;
        border: 0;
        flex: 0 0 auto;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: ${getProp("theme.zIndex.default")};
        transition: all 0.2s linear;

        > span {
            top: 0;
        }

        &[disabled] {
            display: none;
        }

        &:hover,
        &:focus {
            opacity: 100%;
        }
    }
`;

productImageCarouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin-top: 15px;
        position: relative;

        > div {
            width: 100%;
        }
    `,
};

productImageCarouselStyles.prevArrowGridItem = {
    width: 1,
};

productImageCarouselStyles.carouselGridItem = {
    width: 12,
};

productImageCarouselStyles.nextArrowGridItem = {
    width: 1,
};

productImageCarouselStyles.image = {
    css: css`
        ${imageCss};
    `,
};

productImageCarouselStyles.selectedImage = {
    css: css`
        ${imageCss};
        border-color: ${getColor("common.ui3")};
        opacity: 100%;
    `,
};

productImageCarouselStyles.carouselSlideInner = {};

productImageCarouselStyles.prevArrowButton = {
    css: css`
        ${carouselArrowCss};
        left: 0;
    `,
};

productImageCarouselStyles.nextArrowButton = {
    css: css`
        ${carouselArrowCss};
        right: 0;
    `,
};
